var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSocialIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_389_32452)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.7663 12.8368C23.7663 12.0211 23.7001 11.2009 23.559 10.3984H12.2402V15.0194H18.722C18.453 16.5098 17.5888 17.8282 16.3233 18.6659V21.6643H20.1903C22.4611 19.5743 23.7663 16.4877 23.7663 12.8368Z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.2401 24.5619C15.4766 24.5619 18.2059 23.4992 20.1945 21.6649L16.3276 18.6666C15.2517 19.3985 13.8627 19.813 12.2445 19.813C9.11388 19.813 6.45946 17.7009 5.50705 14.8613H1.5166V17.9523C3.55371 22.0044 7.7029 24.5619 12.2401 24.5619Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.50277 14.8612C5.00011 13.3709 5.00011 11.7571 5.50277 10.2667V7.17578H1.51674C-0.185266 10.5666 -0.185266 14.5614 1.51674 17.9522L5.50277 14.8612Z",
  fill: "#FBBC04"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.2401 5.31021C13.9509 5.28375 15.6044 5.92751 16.8434 7.10921L20.2695 3.68316C18.1001 1.64605 15.2208 0.526081 12.2401 0.561356C7.7029 0.561356 3.55371 3.11877 1.5166 7.17535L5.50264 10.2663C6.45064 7.42228 9.10947 5.31021 12.2401 5.31021Z",
  fill: "#EA4335"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_389_32452"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(0 0.560547)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSocialIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SocialIcon.104498c09d65046687cb339f63f4ed50.svg";